export default {
	service: [
		"Service",
		"Event",
		"Uttag",
		"Insättning",
		"Villkor och bestämmelser",
		"Certifikat",
		"Vanliga frågor",
		"Användarhandbok",
		"VIP"
	],
	sign: {
		title: "Inloggad i {0} dag",
		SignIn: "Logga in"
	},
	hotMusicAlbum: "Hot Music Album",
	hotMusic: "Hot Song Charts",
	popular: "Nytt spelande",
	rankings: "Populära filmer",
	top: "TOP{0}",
	OnchainServices: "Onchain-tjänster",
	Real: {
		title: "I realtid",
		list: [
			"Totalt antal onlineanvändare",
			"Genomsnittlig användaroptimeringsvolym",
			"Optimeringsbehov Värmekarta",
			"Plattformens kampanjoptimeringsmängd"
		]
	},
	work: {
		title: "Belöning för inlämning av beställning",
		SignIn: "Få"
	},
	Profit: {
		Profit: "Vinst",
		tabs: ["Vinst", "Bonus", "Konto"],
		TotalBalance: "Totalt saldo",
		TotalLuckyBonus: "Total lyckobonus",
		todayEarnings: "Dagens intäkter",
		availableBalance: "Tillgängligt saldo",
		title: ["Dagens intäkter", "Totala intäkter", "Konto"],
		list: ["Orderintäkter", "Teamintäkter", "Totala intäkter"],
		order: {
			title: "Ordervinst",
			commission: "Orderprovision"
		},
		Analysis: {
			title: "Vinstanalys",
			tips: "Du har gjort {0} transaktioner",
			tabs: ["Dagens vinst", "Total vinst"],
			totalTitle: ["Ordervinst", "Incheckningsvinst", "Teamvinst", "Bonusvinst"]
		}
	},
	CustomerService: {
		title: "Kundtjänstcenter",
		consultation: "Kundtjänstkonsultation",
		btn: "Kontakta oss",
		noticeTitle: "Systemmeddelande"
	},
	addWallet: "Lägg till plånbok",
	taskProgress: "Daglig uppgiftsprogress",
	currentProgress: "Nuvarande uppgiftsförlopp",
	awardsBulletin: `{0} användare vinner {1} {2} pris i uppgiften.`,
	vip: {
		title: "@:vip.title",
		more: "Visa mer"
	},
	stats: {
		title: "Datakällor - Dashboard och API",
		subTitle: "Artiststatistik",
		list: ["Mått", "Artister med aktiva sociala medier", "Uppdateras dagligen"]
	}
};
